import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-blogposts',
  templateUrl: './blogposts.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./blogposts.component.css'],
})
export class BlogpostsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
